// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1__ea30b44a6f93b4d403e8","cls2":"AccountMenuButton-cls2___29eca39821e46997e02 AccountMenuButton-cls1__ea30b44a6f93b4d403e8"};